export const GET_ALLOWANCE_REMARK_REQUSET = "GET_ALLOWANCE_REMARK_REQUSET";
export const GET_ALLOWANCE_REMARK_SUCCESS = "GET_ALLOWANCE_REMARK_SUCCESS";
export const GET_ALLOWANCE_REMARK_FAILURE = "GET_ALLOWANCE_REMARK_FAILURE";
export const LIST_ALL_CITY_REQUEST = 'LIST_ALL_CITY_REQUEST';
export const LIST_ALL_CITY_SUCCESS = "LIST_ALL_CITY_SUCCESS";
export const LIST_ALL_CITY_FAILURE = "LIST_ALL_CITY_FAILURE";
export const RESET_ADMIN_STORE_REQUEST = "RESET_ADMIN_STORE_REQUEST";
export const RESET_ADMIN_STORE_SUCCESS = "RESET_ADMIN_STORE_SUCCESS";